// Note: default: undefined is exactly the same as not setting the default key.
const DELTA_RULES = {
  width: {
    lowerLimit: 0,
    upperLimit: Number.POSITIVE_INFINITY,
  },
  height: {
    lowerLimit: 0,
    upperLimit: Number.POSITIVE_INFINITY,
  },
  x: {
    lowerLimit: Number.NEGATIVE_INFINITY,
    upperLimit: Number.POSITIVE_INFINITY,
  },
  y: {
    lowerLimit: Number.NEGATIVE_INFINITY,
    upperLimit: Number.POSITIVE_INFINITY,
  },
  z: {
    lowerLimit: Number.NEGATIVE_INFINITY,
    upperLimit: Number.POSITIVE_INFINITY,
  },
  background: {
    validationFunction: input => typeof input === 'string',
    default: 'transparent',
  },
  color: {
    validationFunction: input => typeof input === 'string',
    default: '#000000',
  },
  opacity: {
    lowerLimit: 0,
    upperLimit: 1,
    default: 1,
  },
  'font-family': {
    validationFunction: input => typeof input === 'string',
    default: 'Arial',
  },
  'font-size': {
    lowerLimit: 1,
    upperLimit: Number.POSITIVE_INFINITY,
    default: 12,
  },
  'line-height': {
    lowerLimit: 0,
    upperLimit: Number.POSITIVE_INFINITY,
  },
  'font-style': {
    validValues: [undefined, 'normal', 'italic'],
  },
  'font-weight': {
    validValues: [undefined, 'normal', 'bold'],
  },
  'text-align': {
    validValues: ['left', 'center', 'right', 'justify'],
    default: 'center',
  },
  'justify-content': {
    validValues: ['flex-start', 'center', 'flex-end'],
    default: 'center',
  },
  'text-decoration': {
    validValues: [undefined, 'none', 'underline', 'line-through', 'wavy'],
  },
  'border-width': {
    lowerLimit: 0,
    upperLimit: 10,
    default: 0,
  },
  'border-radius': {
    lowerLimit: 0,
    upperLimit: 0.5,
    default: 0,
  },
  'border-style': {
    validValues: [undefined, 'none', 'solid', 'dashed'],
    default: 'none',
  },
  'border-color': {
    validationFunction: input => typeof input === 'string',
    default: '#000000',
  },
  'z-rotation': {
    lowerLimit: 0,
    upperLimit: 360,
    default: 0,
  },
  orientation: {
    validValues: [undefined, 'vertical', 'horizontal'],
    default: 'horizontal',
  },
  hoverColorValue: {
    validationFunction: input => typeof input === 'string',
    default: '#000000',
  },
  hoverBackgroundValue: {
    validationFunction: input => typeof input === 'string',
    default: 'transparent',
  },
  hoverBorderStyle: {
    validValues: [undefined, 'none', 'solid', 'dashed'],
    default: 'none',
  },
  hoverBorderColor: {
    validationFunction: input => typeof input === 'string',
    default: '#000000',
  },
  hoverBorderWidth: {
    lowerLimit: 0,
    upperLimit: 10,
    default: 0,
  },
  hoverBorderRadius: {
    lowerLimit: 0,
    upperLimit: 0.5,
    default: 0,
  },
}

export { DELTA_RULES }
